<template>
  <div class="step-follow-check">
    <!-- フォローチェック セレクトボックス -->
    <div class="form-group">
      <label class="form-label">{{ 'フォローチェック' }}</label>
      <el-select
        v-model="followCheck.enabled"
        class="follow-check-select"
        style="width: 100%"
        :disabled="campaignRunning"
      >
        <el-option :label="'あり'" :value="true" />
        <el-option :label="'なし'" :value="false" />
      </el-select>
      <p class="form-description">
        {{ 'DM上でアカウントフォローをしているか、確認できます。' }}
      </p>
    </div>

    <!-- フォローチェック「あり」の場合のみ表示 -->
    <template v-if="followCheck.enabled">
      <!-- フォロー確認メッセージ -->
      <div class="form-group">
        <label class="form-label">
          {{ 'フォロー確認メッセージ' }}
          <span class="required-badge">{{ '必須' }}</span>
        </label>
        <el-input
          v-model="followCheck.confirmMessage"
          type="textarea"
          :rows="3"
          class="confirm-message-field"
          :class="{ 'is-error': errors[1] && errors[1].confirmMessage }"
          :placeholder="'あなたはアカウントをフォローしてますか?'"
        />
        <div v-if="errors[1] && errors[1].confirmMessage" class="input-invalid-text">
          {{ errors[1].confirmMessage }}
        </div>
      </div>

      <!-- フォローしてない場合のコメント -->
      <div class="form-group">
        <label class="form-label">
          {{ 'フォローしてない場合のコメント' }}
          <span class="required-badge">{{ '必須' }}</span>
        </label>
        <el-input
          v-model="followCheck.notFollowingMessage"
          type="textarea"
          :rows="3"
          class="not-following-message-field"
          :class="{ 'is-error': errors[1] && errors[1].notFollowingMessage }"
          :placeholder="'フォロワー限定のキャンペーンです！\nプロフィールからアカウントをフォローしてください！'"
        />
        <div v-if="errors[1] && errors[1].notFollowingMessage" class="input-invalid-text">
          {{ errors[1].notFollowingMessage }}
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { watch } from 'vue'

import { useInstagramScenarioEditorStore } from '@/client/features/instagram_instantwin_prize/hooks/instagramScenarioEditorStore'
// Store
const store = useInstagramScenarioEditorStore()
const { followCheck, errors, campaignRunning } = storeToRefs(store)

// フォローチェックの変更を監視してリアルタイムバリデーション
watch(
  followCheck,
  newValue => {
    // フォローチェック「なし」の場合はエラーをクリア
    if (!newValue.enabled) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [1]: _, ...rest } = store.errors
      store.errors = rest
      return
    }

    // フォローチェック「あり」の場合はバリデーション実行
    store.validateStep1()
  },
  { deep: true }
)
</script>

<style scoped lang="scss">
@use 'sass:math';
@use '@/client/assets/scss/variables.scss' as *;

.step-follow-check {
  .form-group {
    margin-bottom: $spacing-unit * 2;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .form-label {
    display: block;
    margin-bottom: $spacing-unit;
    font-size: 14px;
    font-weight: 500;
    color: $text-color;

    .required-badge {
      display: inline-block;
      padding: 2px 8px;
      margin-left: $spacing-unit;
      font-size: 12px;
      font-weight: normal;
      color: $text-color-white;
      background-color: $danger-color;
      border-radius: 12px;
    }
  }

  .form-description {
    margin-top: $spacing-unit;
    font-size: 12px;
    line-height: 1.5;
    color: $sub-text-color;
  }

  .input-invalid-text {
    margin-top: math.div($spacing-unit, 2);
    font-size: 14px;
    color: $danger-color;
  }

  .is-error {
    :deep(.el-textarea__inner) {
      border-color: $danger-color !important;
    }
  }
}
</style>
